import addonCarousels from '../../data/addOnCarousels.json'

export const getAddonCarousels = () => {
  if (typeof addonCarousels === 'undefined') {
    return []
  } else {
    return addonCarousels
  }
}

export const getAddonCarouselById = (id: string) =>
  getAddonCarousels().find((addon) => addon.id === id)
